import { useQuery } from "@tanstack/react-query";
import { QueryParams } from "../type";
import { TEAM_KEYS } from "./team.keys";
import { teamServices } from "./team.services";

export const useGetTeams = (params?: QueryParams) => {
  return useQuery({
    queryKey: TEAM_KEYS.GET_TEAMS(params),
    queryFn: () => teamServices.getTeams(params),
  });
};

export const useGetTeamById = (id?: string) => {
  return useQuery({
    queryKey: TEAM_KEYS.GET_TEAM_BY_ID(id!),
    queryFn: () => teamServices.getTeamById(id!),
    enabled: !!id,
  });
};
